import { useContext } from "react"

import type { OverlayLoaderContextValue } from "./OverlayLoaderContext"
import { OverlayLoaderContext } from "./OverlayLoaderContext"

export function useOverlayLoader(): OverlayLoaderContextValue {
  const context = useContext(OverlayLoaderContext)

  if (context === null) {
    throw new Error(
      "useOverlayLoader must be used within an OverlayLoaderProvider",
    )
  }

  return context
}
